import React, { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { Helmet } from '../utils/helmet';
import styles from './LoginPopup.module.css';
import { useTranslation } from 'react-i18next';

function LoginPopup({ isOpen, onClose, onSwitchToSignup }) {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [googleLoading, setGoogleLoading] = useState(false);
	const { login, loginWithGoogle } = useUser();
  const { t } = useTranslation();

  const resetForm = () => {
		setEmail('');
		setPassword('');
		setError('');
	};

	useEffect(() => {
		if (!isOpen) {
			resetForm();
			setLoading(false);
			setGoogleLoading(false);
		}
	}, [isOpen]);

	const navigate = typeof window !== 'undefined' ? (path) => { window.location.href = path; } : () => {};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		const result = await login(email, password);
		if (result.success) {
			resetForm();
			onClose();
			navigate('/browse');
		} else {
			setError(result.message);
		}
		setLoading(false);
	};

  const handleGoogleLogin = async () => {
		setError('');
		setGoogleLoading(true);
		const result = await loginWithGoogle();
		if (result.success) {
			resetForm();
			onClose();
			navigate('/browse');
		} else {
			setError(result.message);
		}
		setGoogleLoading(false);
	};

	if (!isOpen) return null;

	return (
		<>
			<Helmet>
				<title>{t('auth.login.helmetTitle')}</title>
				<meta name="description" content={t('auth.login.helmetDescription')} />
			</Helmet>
		<div className={styles.modalOverlay} onClick={() => { resetForm(); onClose(); }}>
			<div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
				<button className={styles.closeBtn} onClick={() => { resetForm(); onClose(); }}>×</button>

				<div className={styles.modalBody}>
					<h2>{t('auth.login.title')}</h2>

					<form onSubmit={handleSubmit} className={styles.form}>
						{error && <div className={styles.error}>{error}</div>}

						<div className={styles.formGroup}>
							<label htmlFor="email">{t('auth.shared.email')}:</label>
							<input
								type="email"
								id="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
								className={styles.input}
								placeholder={t('auth.shared.emailPlaceholder')}
							/>
						</div>

						<div className={styles.formGroup}>
							<label htmlFor="password">{t('auth.shared.password')}:</label>
							<input
								type="password"
								id="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
								className={styles.input}
							/>
						</div>

						<button type="submit" className={styles.submitBtn} disabled={loading}>
							{loading ? t('auth.login.submitting') : t('auth.login.submit')}
						</button>
					</form>

					<div style={{ margin: '0.75rem 0' }}>
						<div style={{ margin: '0.5rem 0', color: 'var(--secondary-text-color)' }}>{t('auth.shared.or')}</div>
						<button
							type="button"
							className={styles.googleBtn}
							onClick={handleGoogleLogin}
							disabled={googleLoading}
						>
							{googleLoading ? t('auth.shared.googleLoading') : t('auth.shared.google')}
						</button>
					</div>

					<div className={styles.switchAuth}>
						<p>{t('auth.login.switchPrompt')}</p>
						<button onClick={onSwitchToSignup} className={styles.switchBtn}>
							{t('auth.login.switchAction')}
						</button>
					</div>
				</div>
			</div>
		</div>
		</>
	);
}

export default LoginPopup;
